module.exports = __webpack_public_path__ + "img/pending.a3d0c2cc.png";